import CentralProfile from './CentralProfile.jsx';

export default CentralProfile;
